import moment from "moment-timezone";

// `timezone` pins the slot moments to the user's selected calendar timezone so
// every wall-clock read (format, hour bucketing, day matching) happens in that
// frame instead of the browser's. Instants are unchanged.
export const processTimeslots = (timeslots, timezone?: string) => ([...(timeslots || [])]
  .sort((a, b) => (a.start > b.start ? 1 : -1))
  .map((slot) => ({
    start: timezone ? moment(slot.start).tz(timezone) : moment(slot.start),
    rawStart: slot.start,
    resource_id: slot.resources[0].id,
    rawEnd: slot.end,
    end: timezone ? moment(slot.end).tz(timezone) : moment(slot.end),
  })))

export const shouldDisableDate = (date, slots) => {
  const dayFormat = date.format('YYYY-MM-DD')
  const sameDaySlots = slots.filter((slot) => {
    const slotDayFormat = slot.start.format('YYYY-MM-DD')
    return slotDayFormat === dayFormat
  })
  return sameDaySlots.length === 0;
}

export const getCurrentDaySlots = (currentDate, slots, timezone?: string) => {
  // Resolve the cursor's calendar day in the same frame the slots are pinned
  // to — a click on e.g. an Auckland-labelled grid row can fall on a
  // different browser-local date.
  const dayFormat = (timezone ? moment(currentDate).tz(timezone) : moment(currentDate)).format('YYYY-MM-DD')
  return slots.filter((slot) => {
    const slotDayFormat = slot.start.format('YYYY-MM-DD')
    return slotDayFormat === dayFormat
  })
}
